import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BaseConfirmationDialogComponent, ReferenceDataService, RomeNotificationService } from 'rome-library';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService, TokenStore } from '../..';
import { States } from '../../../shared';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'boi-gdpr-privacy-notice-dialog',
  templateUrl: './gdpr-privacy-notice-dialog.component.html'
})
export class GdprPrivacyNoticeDialogComponent extends BaseConfirmationDialogComponent<string> {
  @Output() public readonly openGdprDialog = new EventEmitter<boolean>();

  constructor(
    private readonly userService: UserService,
    private readonly tokenStore: TokenStore,
    private readonly router: Router,
    private readonly loginService: LoginService,
    private readonly referenceDataService: ReferenceDataService,
    private readonly notificationService: RomeNotificationService
  ) {
    super();
  }

  public close(): void {
    const isPrivacyNoticeAccepted = this.tokenStore.getUserContext().AcceptsPrivacyNotes;

    if (!isPrivacyNoticeAccepted) {
      this.loginService.logout(States.Login).subscribe();
    }
    super.close();
  }

  public declinePrivacyNotice(): void {
    this.close();
    this.loginService.logout(States.Login).subscribe();
  }

  public acceptPrivacyNotice(): void {
    const userContext = this.tokenStore.getUserContext();

    userContext.AcceptsPrivacyNotes = true;
    this.tokenStore.setUserContext(userContext);
    this.userService
      .acceptPrivacyNotice()
      .pipe(
        catchError((error) => {
          this.notificationService.showError(error.Message);

          return of(undefined);
        }),
        untilDestroyed(this)
      )
      .subscribe(() => this.close());
  }
}
